<template>
	<div class="school-map loading-school-map" style="display: flex;">
		<img
			style="margin: auto;"
			src="https://image.noelshack.com/fichiers/2020/02/5/1578650202-spinner-1s-200px.gif"
			alt="loading-animation"
		/>
	</div>
</template>

<script>
export default {
	name: "Loading"
};
</script>
